import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { variables } from '../variables';

export const offerFormatting = css`
  :host {
    font-family: 'Neue Helvetica W01', Helvetica, Arial, sans-serif;

    color: var(--gray-900);
  }
  .container {
    display: flex;
  }

  .divider {
    border-right: 1px solid #CCC;
    margin: 20px 0;
  }

  .column {
    width: 30%;
    padding: 20px;
  }

  .header {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 30px;
  }

  .option {
    display: flex;
    align-items: start;
    margin: 10px;

    font-size: 14px;
  }

  .option input {
    margin-right: 10px;
  }

  .description {
    display: inline-block;
    font-weight: 400;
    color: var(--gray-600);
  }

  .description label {
    font-weight: 500;
    color: var(--gray-900);
  }
`;

@customElement('apt-combo-offer')
export class ComboOffer extends LitElement {
  private FIRST = 'first';
  private SECOND = 'second';
  private OPERATOR = 'operator';

  @property({})
  firstField = 'dollarMarketShare';

  @property({})
  secondField = 'absoluteDollars';

  @property({})
  operator = 'AND';

  static override get styles() {
    return [variables, offerFormatting];
  }

  override render() {
    return html`
    <div class="container">
      <div class="column">
        <div class="header">Select First Option</div>
        <div class="option">
          <input
            type="radio"
            name="first"
            id="dollarMarketShare"
            value="dollarMarketShare"
            checked
            @click="${(e: Event) => this.radioButtonHandler(e, this.FIRST)}"
          />
          <div class="description">
            <label for="dollarMarketShare">Spend Market Share</label><br />
            Buyer commits this percentage of their spend to the seller.
          </div>
        </div>
        <div class="option">
          <input
            type="radio"
            name="first"
            id="unitMarketShare"
            value="unitMarketShare"
            @click="${(e: Event) => this.radioButtonHandler(e, this.FIRST)}"
          />
          <div class="description">
            <label for="unitMarketShare">Unit Market Share</label><br />
            Buyer commits this percentage of their units to the seller.
          </div>
        </div>
      </div>
      <div class="divider"></div>
      <div class="column">
        <div class="header">Select Type of Scenario</div>
        <div class="option">
          <input
            type="radio"
            name="type"
            id="and"
            value="AND"
            checked
            @click="${(e: Event) => this.radioButtonHandler(e, this.OPERATOR)}"
          />
          <div class="description">
            <label for="and">And</label>
          </div>
        </div>
        <div class="option">
          <input
            type="radio"
            name="type"
            id="or"
            value="OR"
            @click="${(e: Event) => this.radioButtonHandler(e, this.OPERATOR)}"
          />
          <div class="description">
            <label for="or">Or</label>
          </div>
        </div>
      </div>
      <div class="divider"></div>
      <div class="column">
        <div class="header">Select Second Option</div>
        <div class="option">
          <input
            type="radio"
            name="second"
            id="absoluteDollars"
            value="absoluteDollars"
            checked
            @click="${(e: Event) => this.radioButtonHandler(e, this.SECOND)}"
          />
          <div class="description">
            <label for="absoluteDollars">Spend Volume</label><br />
            Buyer commits this spend volume to the seller.
          </div>
        </div>
        <div class="option">
          <input
            type="radio"
            name="second"
            id="absoluteUnits"
            value="absoluteUnits"
            @click="${(e: Event) => this.radioButtonHandler(e, this.SECOND)}"
          />
          <div class="description">
            <label for="absoluteUnits">Unit Volume</label><br />
            Buyer commits this unit volume to the seller.
          </div>
        </div>
      </div>
    </div>
    `;
  }

  radioButtonHandler(event: Event, type: string) {
    switch (type) {
      case this.FIRST:
        this.firstField = (event.target as HTMLInputElement)?.value;
        break;
      case this.SECOND:
        this.secondField = (event.target as HTMLInputElement)?.value;
        break;
      case this.OPERATOR:
        this.operator = (event.target as HTMLInputElement)?.value;
        break;
    }
  }
}
